export default __webpack_public_path__ + "static/img25h-1d7aedaf503d509481e3c4fe9162e04d.jpg";